/**
 * Product Lens Builder Link Handler
 * Intercepts "Build This Lens" button clicks and adds product ID to URL
 */

(function() {
  'use strict';
  
  console.log('🔘 Product Lens Builder Link script loaded');
  
  function initBuildThisLensButton() {
    // Find the "Build This Lens" button - look for button with text "Build This Lens"
    // Exclude mobile drawer menu buttons
    const allButtons = document.querySelectorAll('a[href*="lens-builder"]');
    
    let buildButton = null;
    
    // Find the one that's NOT in the mobile drawer
    allButtons.forEach(btn => {
      if (!btn.id.includes('Drawer') && !btn.closest('.menu-drawer')) {
        buildButton = btn;
      }
    });
    
    if (!buildButton) {
      console.log('ℹ️ No "Build This Lens" button found on this page');
      return;
    }
    
    console.log('✅ Found "Build This Lens" button:', buildButton);
    
    buildButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      console.log('🔘 Build This Lens clicked');
      
      // ✅ Clear old cart edit session storage before navigating
      console.log('🧹 Clearing old cart edit session storage');
      sessionStorage.removeItem('lensBuilderEditConfig');
      sessionStorage.removeItem('lensBuilderEditKey');
      sessionStorage.removeItem('lensBuilderFromCart');
      
      // Get product ID from the page
      let productId = null;
      
      // Method 1: Check for product JSON in script tag
      const productScript = document.querySelector('script[type="application/json"][data-product-json]');
      if (productScript) {
        try {
          const productData = JSON.parse(productScript.textContent);
          if (productData.id) {
            productId = productData.id;
          }
        } catch (e) {
          console.log('Could not parse product JSON from script tag');
        }
      }
      
      // Method 2: Check for product form
      if (!productId) {
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          const productIdData = productForm.querySelector('[data-product-id]');
          if (productIdData) {
            productId = productIdData.dataset.productId;
          }
        }
      }
      
      // Method 3: Check for data attribute on product section - EXCLUDE DRAWERS
      if (!productId) {
        const allProductIdElements = document.querySelectorAll('[data-product-id]');
        for (const el of allProductIdElements) {
          // Skip anything inside a drawer or menu
          if (el.closest('#Details-menu-drawer-container') || 
              el.closest('.menu-drawer') || 
              el.closest('[id*="drawer"]') ||
              el.closest('[id*="Drawer"]')) {
            continue;
          }
          productId = el.dataset.productId;
          break;
        }
      }
      
      // Method 4: Check window.ShopifyAnalytics (if available)
      if (!productId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        productId = window.ShopifyAnalytics.meta.product.id;
      }
      
      // Method 5: Check for product JSON-LD
      if (!productId) {
        const jsonLd = document.querySelector('script[type="application/ld+json"]');
        if (jsonLd) {
          try {
            const data = JSON.parse(jsonLd.textContent);
            if (data.productID) {
              productId = data.productID;
            }
          } catch (e) {
            console.log('Could not parse JSON-LD');
          }
        }
      }
      
      if (productId) {
        console.log('✅ Product ID found:', productId);
        console.log('🔗 Navigating to lens builder with product ID');
        window.location.href = '/pages/lens-builder?lens_id=' + productId;
      } else {
        console.error('❌ Could not find product ID');
        console.log('🔍 Trying to find product data in page...');
        console.log('   Available scripts:', document.querySelectorAll('script[type*="json"]'));
        console.log('   Product forms:', document.querySelectorAll('form[action*="/cart/add"]'));
        alert('Unable to load product information. Please try again.');
      }
    });
    
    console.log('✅ Build This Lens button initialized');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuildThisLensButton);
  } else {
    initBuildThisLensButton();
  }
  
})();
